import { cn } from '@/utils/cn'
import { Suspense } from 'react'
import type { ReactNode } from 'react'
import { Loading } from '../Loading/index'

interface SuspenseBoundaryProps {
  children: ReactNode
  loadingClassName?: string
  fallback?: ReactNode
  relative?: boolean
  minHeight?: number
}

export const SuspenseBoundary = ({ children, loadingClassName, fallback, relative = false, minHeight = 300 }: SuspenseBoundaryProps) => {

  if (relative) {
    return <div className='relative' style={{ minHeight: minHeight }}>
      <Suspense fallback={fallback || <Loading className={cn(loadingClassName, 'absolute')} />}>{children}</Suspense>
    </div>
  }

  return <Suspense fallback={fallback || <Loading className={loadingClassName} />}>{children}</Suspense>
}
